export const SubmitForCoordinationDialogMessage = {
    modalTitle: 'Coordination Submission Complete!',
    modalContent: 'Check the dashboard for status updates.',
    primaryActionTitle: 'Return to Dashboard',
} as const;

export const SubmitForCoordinationDialogMessageConstants = {
    coordinationProhibitedMessage:
        'The current application status prevents submission for coordination. Please contact an EWA Advisor.',
    actionText: 'OK',
} as const;
